module.exports = __webpack_public_path__ + "img/0006.06db9551.jpg";